import React from 'react';
import { LinearProgress } from '@mui/material';
import { tokens } from './tokens';

export const GoalProgressBar: React.FC<{ completed: number; total: number }> = ({ completed, total }) => (
  <LinearProgress
    variant="determinate"
    value={(completed / total) * 100}
    aria-label={`Activity ${completed} of ${total}`}
    sx={{ height: 6, borderRadius: 999, bgcolor: tokens.track, '& .MuiLinearProgress-bar': { borderRadius: 999 } }}
  />
);
